"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4188,2968],{

/***/ 24055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile_tab_nav_button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button.scss.js



var StyledMobileTabNavButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "ewy7dq00"
})("font-size:0.875rem;font-weight:500;padding:7px 16px 9px;border-radius:20px;background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";white-space:nowrap;transition:background-color 0.2s ease-in-out,color 0.2s ease-in-out;&.selected{background-color:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}&.background-gray{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";}}&.crm-green{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.marketing-red{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.projects-orange{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.dev-green{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.white{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";&.selected{background-color:rgba(255,255,255,0.2);border-color:rgba(255,255,255,0.2);color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.dev-lighter-tint-01{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";&.selected{background-color:", colors/* default */.Z[color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";border-color:", colors/* default */.Z[color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME], ";}}&.crm-dark-tint-01{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";&.selected{background-color:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";}}&.crm-darker-tint-02{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";&.selected{background-color:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button.js



var MobileTabNavButton = function(props) {
    var label = props.label, selected = props.selected, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileTabNavButton, {
        className: classnames_default()("tab-nav-button", {
            selected: selected
        }, theme),
        children: label
    });
};
/* harmony default export */ var mobile_tab_nav_button = (MobileTabNavButton);


/***/ }),

/***/ 35998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile_tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.scss.js


var StyledMobileTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bx2fs30"
})('*:focus{outline:none !important;}.carousel{.slick-slider.focus{.slick-list{.slick-track{padding:0;}}}}.mobile-tabs-navigation{overflow-x:auto;&::-webkit-scrollbar{display:none;}display:flex;gap:8px;padding-left:16px;.tab-nav-button-wrapper{display:flex;white-space:nowrap;}&::after{content:"";padding-right:16px;}}@media (min-width:', vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){.carousel{.slick-slide{.side-by-side-text-and-asset{.side-by-side-content{.full-paragraph-component-wrapper{padding:0;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var VISIBILITY_SENSOR_OFFSET = -100;
var CAROUSEL_LEFT_SWIPE = "left";
var CAROUSEL_RIGHT_SWIPE = "right";
var MobileTabs = function(props) {
    var ref = (0,react.useState)(null), carouselRef = ref[0], setCarouselRef = ref[1];
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var itemsRef = (0,react.useRef)([]);
    var tabs = props.tabs, selectedTab = props.selectedTab, setSelectedTab = props.setSelectedTab, navigationItemRenderer = props.navigationItemRenderer, carouselItemRenderer = props.carouselItemRenderer, wasComponentEverVisible = props.wasComponentEverVisible, setWasComponentEverVisible = props.setWasComponentEverVisible;
    var onVisibilityChange = function(isVisibleValue) {
        if (!wasComponentEverVisible && isVisibleValue) {
            setWasComponentEverVisible(true);
            if (selectedTab !== 0) {
                var _itemsRef_current_selectedTab, _itemsRef_current;
                itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_selectedTab = _itemsRef_current[selectedTab]) === null || _itemsRef_current_selectedTab === void 0 ? void 0 : _itemsRef_current_selectedTab.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
        setIsVisible(isVisibleValue);
    };
    var tabsWithVideoPlayerRefs = [];
    tabs.forEach(function(tab) {
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            videoPlayerRef: (0,react.useRef)(null)
        }));
    });
    (0,react.useEffect)(function() {
        itemsRef.current = itemsRef.current.slice(0, tabsWithVideoPlayerRefs.length);
    }, [
        tabsWithVideoPlayerRefs
    ]);
    var onTabClicked = function(element, tab, index) {
        setSelectedTab(index);
        element.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
            kind: tab.tabLabel,
            info1: index
        });
    };
    (0,react.useEffect)(function() {
        var _currentTab_videoPlayerRef;
        var currentTab = tabsWithVideoPlayerRefs[selectedTab];
        if (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_videoPlayerRef = currentTab.videoPlayerRef) === null || _currentTab_videoPlayerRef === void 0 ? void 0 : _currentTab_videoPlayerRef.current) {
            currentTab.videoPlayerRef.current.seekTo(0);
        }
        carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.slickGoTo(selectedTab);
    }, [
        selectedTab
    ]);
    var scrollToNavigationTabIfVisible = function(index) {
        if (isVisible) {
            var _itemsRef_current_index, _itemsRef_current;
            itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_index = _itemsRef_current[index]) === null || _itemsRef_current_index === void 0 ? void 0 : _itemsRef_current_index.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    var navItemRenderer = function(tab, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tab-nav-button-wrapper",
            ref: function(element) {
                return itemsRef.current[index] = element;
            },
            onClick: function(event) {
                return onTabClicked(event.target, tab, index);
            },
            children: navigationItemRenderer(tab, index)
        });
    };
    var carouselProps = {
        items: tabsWithVideoPlayerRefs,
        itemRenderer: carouselItemRenderer,
        defaultIndex: wasComponentEverVisible ? 0 : selectedTab,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: -1,
        centerPadding: "5%",
        centerMode: false,
        infinite: false,
        fade: false,
        onRefSet: setCarouselRef
    };
    var onCarouselChange = function(current) {
        // fix selectedTab index in case of a glitch
        if (current !== selectedTab) {
            setSelectedTab(current);
            scrollToNavigationTabIfVisible(current);
        }
    };
    var onCarouselSwipe = function(direction) {
        var newSlide = selectedTab;
        if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
            newSlide = selectedTab + 1;
        }
        if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
            newSlide = selectedTab - 1;
        }
        setSelectedTab(newSlide);
        scrollToNavigationTabIfVisible(selectedTab);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileTabs, {
            className: "mobile-tabs-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-tabs-navigation",
                    children: tabsWithVideoPlayerRefs.map(function(tab, index) {
                        return navItemRenderer(tab, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread_props(_object_spread({}, carouselProps), {
                        onChange: function(current) {
                            return onCarouselChange(current);
                        },
                        onSwipe: onCarouselSwipe
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_tabs = (MobileTabs);


/***/ }),

/***/ 54188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ building_blocks_tabs_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js + 1 modules
var two_thirds_text_and_asset_component = __webpack_require__(32968);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var _TwoThirdsTextAndAssetComponent_defaultProps_asset = two_thirds_text_and_asset_component["default"].defaultProps.asset, default_props_image = _TwoThirdsTextAndAssetComponent_defaultProps_asset.image, selectedAssetComponentDefaultProps = _object_without_properties(_TwoThirdsTextAndAssetComponent_defaultProps_asset, [
    "image"
]);
/* harmony default export */ var default_props = ({
    buildingBlocksTabsTheme: segments_service/* WORKOS_IRIS_THEME_ID */.M1,
    tabs: [
        {
            tabLabel: "Boards",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/board_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Boards",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    body: "Everything starts with a visual board — the core of monday.com Work OS. Tailor it your way and manage anything from projects to departments."
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/7_status.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        },
        {
            tabLabel: "Views",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/views_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Views",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    body: "Visualize and plan your work more efficiently with multiple views: Kanban board, calendar, timeline, Gantt chart, and more."
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/1_Views.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        },
        {
            tabLabel: "Dashboards",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/dashboard_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Dashboards",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    buttonConfig: {
                        buttonType: "Secondary",
                        buttonText: "Learn more",
                        url: links/* DASHBOARDS_PAGE_LINK */.yCu
                    },
                    body: "Get the insights you need to make decisions with confidence. Keep track of progress, timelines, and budgets with custom dashboards."
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/2_Dashboards.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        },
        {
            tabLabel: "Integrations",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/integrations_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Integrations",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    buttonConfig: {
                        buttonType: "Secondary",
                        buttonText: "Learn more",
                        url: links/* INTEGRATIONS_PAGE_LINK */.oUX
                    },
                    body: "Connect monday.com with all your favorite tools and get more work done. Integrate Slack, Dropbox, Adobe Creative Cloud, and more."
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/4_Integrations.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        },
        {
            tabLabel: "Automations",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/automations_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Automations",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    buttonConfig: {
                        buttonType: "Secondary",
                        buttonText: "Learn more",
                        url: links/* AUTOMATIONS_PAGE_LINK */.cPO
                    },
                    body: "Streamline processes to focus on the work that matters. Choose from a variety of automation recipes or create your own in minutes."
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/3_Automations.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        },
        {
            tabLabel: "Apps",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/apps_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Apps",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    buttonConfig: {
                        buttonType: "Secondary",
                        buttonText: "Learn more",
                        url: links/* APPS_MARKETPLACE_LINK */.IHo
                    },
                    body: "Expand the capabilities of your Work OS with monday apps. Enhance your workflows with custom views, widgets, integrations, and more. "
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/5_Apps.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        },
        {
            tabLabel: "Docs",
            tabIcon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured images/Home Page - 2022 Rebrand/tabs/docs_icon.svg",
            textAndAsset: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps), {
                swapTextAndAssetPosition: true,
                fullParagraph: _object_spread_props(_object_spread({}, two_thirds_text_and_asset_component["default"].defaultProps.fullParagraph), {
                    topic: {},
                    title: "Docs",
                    titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    buttonConfig: {
                        buttonType: "Secondary",
                        buttonText: "Learn more",
                        url: links/* WORKDOCS_PAGE_LINK */.RdE
                    },
                    body: "Transform text into action items, in just a few clicks. Connect, collaborate, and execute ideas and workflows in real-time from any doc."
                }),
                asset: _object_spread_props(_object_spread({}, selectedAssetComponentDefaultProps), {
                    video: {
                        loop: true,
                        src: {
                            formats: [
                                "/Generator_featured images/Home Page - 2022 Rebrand/tabs/final-videos-tabs/6_Docs.mp4"
                            ]
                        }
                    },
                    position: "center",
                    useWindowMask: true
                })
            })
        }
    ]
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.js + 1 modules
var mobile_tabs = __webpack_require__(35998);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button.js + 1 modules
var mobile_tab_nav_button = __webpack_require__(24055);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tab-content/building-blocks-tab-content-component.scss.js


var StyledBuildingBlocksTabContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emqkxra0"
})("visibility:hidden;opacity:0;transition:0.3s;// keep 1st child relative to determine the component size\n  &:not(:first-child){position:absolute;top:0;left:0;}&.selected{visibility:visible;opacity:1;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.side-by-side-text-and-asset{.side-by-side-content.is-swap{flex-direction:column-reverse;}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tab-content/building-blocks-tab-content-component.js
function building_blocks_tab_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tab_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tab_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function building_blocks_tab_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function building_blocks_tab_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        building_blocks_tab_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var BuildingBlocksTabContentComponent = function(props) {
    var tab = props.tab, isSelected = props.isSelected, themeColor = props.themeColor, isAssetVisible = props.isAssetVisible, isMobileDisplay = props.isMobileDisplay;
    var getTextAndAssetProps = function() {
        return building_blocks_tab_content_component_object_spread_props(building_blocks_tab_content_component_object_spread({}, tab.textAndAsset), {
            hideControls: true,
            asset: isAssetVisible ? building_blocks_tab_content_component_object_spread_props(building_blocks_tab_content_component_object_spread({}, tab.textAndAsset.asset), {
                video: building_blocks_tab_content_component_object_spread_props(building_blocks_tab_content_component_object_spread({}, tab.textAndAsset.asset.video), {
                    videoPlayerRef: tab.videoPlayerRef
                })
            }) : {},
            fullParagraph: building_blocks_tab_content_component_object_spread_props(building_blocks_tab_content_component_object_spread({}, tab.textAndAsset.fullParagraph), {
                titleIcon: (0,cloudinary_service.getUrlWithColor)({
                    url: tab === null || tab === void 0 ? void 0 : tab.tabIcon,
                    color: colors/* default */.Z[themeColor]
                }),
                titleColor: themeColor,
                title: isMobileDisplay ? "" : tab.textAndAsset.fullParagraph.title
            }),
            textSize: isMobileDisplay ? sizes.SM : tab.textAndAsset.fullParagraph.textSize
        });
    };
    var textAndAssetProps = getTextAndAssetProps();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBuildingBlocksTabContentComponent, {
        className: classnames_default()("building-blocks-content-wrapper", {
            selected: isSelected
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(two_thirds_text_and_asset_component["default"], building_blocks_tab_content_component_object_spread_props(building_blocks_tab_content_component_object_spread({}, textAndAssetProps), {
            useWindowMask: tab.textAndAsset.asset.useWindowMask
        }))
    });
};
BuildingBlocksTabContentComponent.defaultProps = {
    isSelected: true,
    isAssetVisible: true
};
/* harmony default export */ var building_blocks_tab_content_component = (BuildingBlocksTabContentComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-mobile-component/building-blocks-tabs-mobile-component.scss.js

var StyledBuildingBlocksTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18uurwr0"
})(".secondary-button{.secondary-button-text{font-size:0.8125rem;}.arrow-wrapper{svg{height:12px;width:10px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-mobile-component/building-blocks-tabs-mobile-component.js
function building_blocks_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function building_blocks_tabs_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function building_blocks_tabs_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        building_blocks_tabs_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var BuildingBlocksTabsMobileComponent = function(props) {
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(false), wasComponentEverVisible = ref1[0], setWasComponentEverVisible = ref1[1];
    var buildingBlocksTabsTheme = props.buildingBlocksTabsTheme;
    var navigationItemRenderer = function(tab, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_tab_nav_button/* default */.Z, {
            label: tab.tabLabel,
            selected: selectedTab === index,
            theme: buildingBlocksTabsTheme
        });
    };
    var carouselItemRenderer = function(tab, index) {
        var isSelected = index === selectedTab;
        // bring the first asset on load, and bring everything else when component is visible
        var isAssetVisible = wasComponentEverVisible || isSelected;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(building_blocks_tab_content_component, {
            tab: tab,
            isAssetVisible: isAssetVisible,
            buildingBlocksTabsTheme: buildingBlocksTabsTheme,
            themeColor: buildingBlocksTabsTheme,
            isMobileDisplay: true
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBuildingBlocksTabsMobileComponent, {
        className: "building-blocks-tabs-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_tabs/* default */.Z, building_blocks_tabs_mobile_component_object_spread_props(building_blocks_tabs_mobile_component_object_spread({}, props), {
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            wasComponentEverVisible: wasComponentEverVisible,
            setWasComponentEverVisible: setWasComponentEverVisible,
            navigationItemRenderer: navigationItemRenderer,
            carouselItemRenderer: carouselItemRenderer
        }))
    });
};
/* harmony default export */ var building_blocks_tabs_mobile_component = (BuildingBlocksTabsMobileComponent);

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tab/building-blocks-tab-component.scss.js



var StyledBuildingBlocksTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12oxrlm0"
})("display:flex;flex-direction:column;justify-content:space-evenly;position:relative;cursor:pointer;padding:0 20px;align-items:center;min-width:100px;user-select:none;.icon-wrapper{display:flex;justify-content:center;padding-top:8px;opacity:0.6;position:relative;.icon-absolute-container{position:absolute;top:0;opacity:0;&.visible{opacity:1;}}}.name{font-weight:300;opacity:0.6;}.marker{position:absolute;bottom:0;left:0;height:4px;width:100%;border-top-left-radius:8px;border-top-right-radius:8px;transition:background-color 0.1s ease-in-out;}&.selected{cursor:pointer;.icon-wrapper{opacity:1;}.name{opacity:1;}}&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tab/building-blocks-tab-component.js
function building_blocks_tab_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tab_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tab_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function building_blocks_tab_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function building_blocks_tab_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        building_blocks_tab_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var DEFAULT_ICON_SIZE = "16px";
var BuildingBlocksTabComponent = function(props) {
    var _productsColorOptionsOvertonesMap_themeColor;
    var buildingBlock = props.buildingBlock, index = props.index, selectedTab = props.selectedTab, setSelectedTab = props.setSelectedTab, themeColor = props.themeColor;
    var isSelected = index === selectedTab;
    var tabSelectedColor = colors/* default */.Z[((_productsColorOptionsOvertonesMap_themeColor = color_picker_constants.productsColorOptionsOvertonesMap[themeColor]) === null || _productsColorOptionsOvertonesMap_themeColor === void 0 ? void 0 : _productsColorOptionsOvertonesMap_themeColor.dark) || color_consts.DARK_WORK_OS_IRIS_COLOR_NAME];
    var getTabIconAsset = function(param) {
        var isSelected = param.isSelected;
        return {
            image: {
                src: (0,cloudinary_service.getUrlWithColor)({
                    url: buildingBlock.tabIcon,
                    color: isSelected ? tabSelectedColor : colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME]
                })
            }
        };
    };
    var selectedTabIconAsset = getTabIconAsset({
        isSelected: true
    });
    var unselectedTabIconAsset = getTabIconAsset({
        isSelected: false
    });
    var selectTab = function(param) {
        var buildingBlock = param.buildingBlock, index = param.index;
        var _buildingBlock_videoPlayerRef;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
            kind: buildingBlock.tabLabel,
            info1: index
        });
        setSelectedTab(index);
        // start video at 0 time
        if (buildingBlock === null || buildingBlock === void 0 ? void 0 : (_buildingBlock_videoPlayerRef = buildingBlock.videoPlayerRef) === null || _buildingBlock_videoPlayerRef === void 0 ? void 0 : _buildingBlock_videoPlayerRef.current) {
            buildingBlock.videoPlayerRef.current.seekTo(0);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBuildingBlocksTabComponent, {
        className: classnames_default()("tab", {
            selected: isSelected
        }),
        onClick: function() {
            return selectTab({
                buildingBlock: buildingBlock,
                index: index
            });
        },
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function() {
            return selectTab({
                buildingBlock: buildingBlock,
                index: index
            });
        }),
        role: "tab",
        "aria-selected": isSelected,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "icon-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("icon-absolute-container", {
                            visible: isSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, building_blocks_tab_component_object_spread_props(building_blocks_tab_component_object_spread({}, selectedTabIconAsset), {
                            width: DEFAULT_ICON_SIZE,
                            height: DEFAULT_ICON_SIZE
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("icon-absolute-container", {
                            visible: !isSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, building_blocks_tab_component_object_spread_props(building_blocks_tab_component_object_spread({}, unselectedTabIconAsset), {
                            width: DEFAULT_ICON_SIZE,
                            height: DEFAULT_ICON_SIZE
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "name",
                style: {
                    color: isSelected ? tabSelectedColor : colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME]
                },
                children: buildingBlock.tabLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "marker",
                style: {
                    backgroundColor: isSelected ? tabSelectedColor : "transparent"
                }
            })
        ]
    }, index);
};
/* harmony default export */ var building_blocks_tab_component = (BuildingBlocksTabComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-desktop-component/building-blocks-tabs-desktop-component.scss.js


var StyledBuildingBlocksTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ex5hyuu0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 0;.building-blocks-tabs-wrapper{height:83px;box-shadow:0px 10px 30px rgba(29,140,242,0.2);border-radius:8px;display:flex;flex-direction:row;margin-bottom:40px;font-size:0.875rem;}.building-blocks-contents-wrapper{width:100%;position:relative;}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-desktop-component/building-blocks-tabs-desktop-component.js
function building_blocks_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function building_blocks_tabs_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function building_blocks_tabs_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        building_blocks_tabs_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var BuildingBlocksTabsDesktopComponent = function(props) {
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(false), wasComponentEverVisible = ref1[0], setWasComponentEverVisible = ref1[1];
    var tabs = props.tabs, buildingBlocksTabsTheme = props.buildingBlocksTabsTheme;
    var VISIBILITY_SENSOR_OFFSET = -100;
    var tabsWithVideoPlayerRefs = [];
    tabs.forEach(function(tab) {
        tabsWithVideoPlayerRefs.push(building_blocks_tabs_desktop_component_object_spread_props(building_blocks_tabs_desktop_component_object_spread({}, tab), {
            videoPlayerRef: (0,react.useRef)(null)
        }));
    });
    var onVisibilityChange = function(isVisible) {
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBuildingBlocksTabsDesktopComponent, {
            className: "building-blocks-tabs-desktop-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "building-blocks-tabs-wrapper",
                    role: "tablist",
                    children: tabsWithVideoPlayerRefs.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(building_blocks_tab_component, {
                            buildingBlock: value,
                            index: index,
                            selectedTab: selectedTab,
                            setSelectedTab: setSelectedTab,
                            themeColor: buildingBlocksTabsTheme
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "building-blocks-contents-wrapper",
                    children: tabsWithVideoPlayerRefs.map(function(tab, index) {
                        var isSelected = index === selectedTab;
                        // bring the first asset on load, and bring everything else when component is visible
                        var isAssetVisible = wasComponentEverVisible || isSelected;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(building_blocks_tab_content_component, {
                            tab: tab,
                            isSelected: isSelected,
                            isAssetVisible: isAssetVisible,
                            buildingBlocksTabsTheme: buildingBlocksTabsTheme,
                            themeColor: buildingBlocksTabsTheme
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var building_blocks_tabs_desktop_component = (BuildingBlocksTabsDesktopComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-component.js




var BuildingBlocksTabsComponent = (0,responsive_hoc_component/* default */.Z)(building_blocks_tabs_desktop_component, building_blocks_tabs_mobile_component);
BuildingBlocksTabsComponent.defaultProps = default_props;
/* harmony default export */ var building_blocks_tabs_component = (BuildingBlocksTabsComponent);


/***/ }),

/***/ 32968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TwoThirdsTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.scss.js

var StyledTwoThirdsTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emxkgw60"
})(".side-by-side-text-and-asset-component{.side-by-side-content{.full-paragraph-component-wrapper{width:40%;}.image-wrapper{width:60%;}&.no-text-component{justify-content:center;.image-wrapper{width:100%;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var TwoThirdsTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoThirdsTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoThirdsTextAndAssetComponent);
    function TwoThirdsTextAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, TwoThirdsTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoThirdsTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoThirdsTextAndAssetComponent, {
                    className: "two-thirds-text-and-asset-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], _object_spread({}, this.props))
                });
            }
        }
    ]);
    return TwoThirdsTextAndAssetComponent;
}(react.PureComponent);

TwoThirdsTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps), {
    fullParagraph: _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.fullParagraph), {
        topic: {
            text: "For the creative process",
            color: "brand-blue"
        },
        title: "Streamline your creative workflow",
        body: "Use customizable forms to request all the information needed. Then, easily share assets and receive feedback in real time."
    }),
    asset: _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset), {
        image: _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
        })
    })
});


/***/ })

}]);